import { createContext } from "react";

const LogPhotoContext = createContext();

export default LogPhotoContext;
